import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  appName: 'Voxor',
  apiBaseUrl: 'https://www.dev.voxor.com.ec/api/v1',
  useMockApi: false,
  useMockAuthApi: false,
  useMockCompaniesApi: false,
  useMockUsersApi: false,
  useMockRolesApi: false,
};
